import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';

const ImageWithFallback = ({ src, alt, fallbackIcon, className = '', onError, ...props }) => {
  const { t } = useTranslation();
  const [imageError, setImageError] = useState(false);

  const handleError = e => {
    setImageError(true);
    if (onError) {
      onError(e);
    }
  };

  if (imageError || !src) {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`} style={{ backgroundColor: colors.mercury }}>
        {fallbackIcon || (
          <svg className="w-12 h-12 mb-3 opacity-50" style={{ color: colors.mineShaft }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        )}
        <p className="text-xs font-medium opacity-75" style={{ color: colors.mineShaft }}>
          {t('BOOK_SECTION.noImageAvailable')}
        </p>
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} onError={handleError} {...props} />;
};

export default ImageWithFallback;
